import { appConfig as $config } from '../../app.config';
import { App } from '../../modules/App';
import { Common } from '../../modules/Common';
import { UI } from '../../modules/UI';
import { User } from '../../modules/User';
import { SortFilter } from '../../modules/SortFilter';
import { ColorVariants } from '../../modules/ColorVariants';
import { DesignStudio } from '../../modules/DesignStudio';
import { MasterProductData } from '../../modules/MasterProductData';
import { ProductApprovalShort } from '../../modules/ProductApprovalShort';
import { ProductApproval } from '../../modules/ProductApproval';
import { ProductApprovalFull } from '../../modules/ProductApprovalFull';
import { SendSample } from '../../modules/SendSample';
import { SendApproval } from '../../modules/SendApproval';
import { ProductInfo } from '../../modules/ProductInfo';
import { ArtworkInfo } from '../../modules/ArtworkInfo';
import { BlankInfo } from '../../modules/BlankInfo';
import { BOM } from '../../modules/BOM';
import { ItemCardNotice } from '../../modules/ItemCardNotice';
import { approvalPdfDialog } from './approvalPdfDialog';
import { AssignTasks } from '../../modules/AssignTasks';
import { ApprovalRejection } from '../../modules/ApprovalRejection';
import { MockupStatus, MockupSubmission } from '../../modules/ReactComponent';
import { Listings } from '../Listings';

import './scss/prelisting.scss';
import { QuickFilters } from '../../modules/SortFilter/quick-filters';

export const Prelisting = (function () {
  let lastQuery;
  let timerId = null;
  let $params;
  let $productInfoDialogParams;
  let $query;
  let $isLicensor = '';

  let mapping = {
    prelisting: (data, params = {}) => {
      let dialog = params && params.action && params.action == 'dialog';
      $.each(data, function (k, v) {
        // Approval Item mapping
        v.approveItem = Common.mapping.approvalObject(v.approveItem);

        v.colors = $.map(v.variants, (variant, i) => {
          return variant.color;
        });

        v.imageExistsUri = v.thumbnailImageUri
          ? v.thumbnailImageUri
          : v.variants.length > 0
            ? v.variants[0].imageUri
            : '';
        v.startPrice = `${v.defaultPrice.currencyValue} ${v.defaultPrice.currencyCode}`;
        v.priceDisplay = Common.priceRange(v.priceRange);
        v.sizes = Common.sizeRange(v.availableSizes);
        v.assetsDisplay = v.assets
          .map((art) => {
            return art.frameType === 0
              ? `<a href="javascript:" data-id="${art.objectId}" class="artwork-name">${art.title}</a>`
              : `${art.title}`;
          })
          .join(', ');
        v.createDateText = moment(v.createdDate).format($config.appFullDateFormat);
        v.selectedcolors = [];
        v.uploadGenerateProcessState =
          v.uploadGenerateProcessState != null ? v.uploadGenerateProcessState : { state: -1 };
        v.productInStores =
          v.storesWithLanguages &&
          $.map(v.storesWithLanguages, (stwl) => {
            return { storeName: stwl.storeDisplayName, langCodes: stwl.languageCodes.toString().toUpperCase() };
          });

        if (v.variants.length > $config.colorVariantsInCard) {
          v.variantsLimit = $config.colorVariantsInCard;
          v.variantsCut = true;
        }
        if (dialog || $isLicensor) {
          v.variants.forEach((variant) => {
            variant.disabled = true;
          });
        }

        updateSubmissionIndication(v);
      });
      return data;
    },
    pageInfoSave: (prelisting) => {
      prelisting.variants = $.map(prelisting.variants, (variant) => {
        variant.approved = $(`.info-item .item-color-checkbox[name="${variant.color}"]`).prop('checked');
        return variant;
      });
      return prelisting;
    }
  };

  let updateSubmissionIndication = (v) => {
    let directoryName;

    (v?.submitStatusInformation?.folderStatusInformations || []).some((statusInformation) => {
      if (statusInformation.status === 3) { // error
        v.submissionIndicationText = statusInformation.statusMessage;
        v.submissionIndicationStatus = 'error';

        return true;
      }

      if (statusInformation.status === 1 || statusInformation.status === 2) { // success || warning
        if (v.submissionIndicationStatus !== 'success' && v.submissionIndicationStatus !== 'warning') {
          directoryName = '';
        }

        v.submissionIndicationStatus = v.submissionIndicationStatus !== 'warning' && statusInformation.status === 2 ? 'success' : 'warning';
        directoryName = directoryName ? `${directoryName}, ${statusInformation.directoryName}` : statusInformation.directoryName;

        return;
      }

      if (statusInformation.status === -1) { // in progress
        if (!v.submissionIndicationStatus || v.submissionIndicationStatus === 'inProgress') {
          if (v.submissionIndicationStatus !== 'inProgress') {
            directoryName = '';
          }

          v.submissionIndicationStatus = 'inProgress';
          directoryName = directoryName ? `${directoryName}, ${statusInformation.directoryName}` : statusInformation.directoryName;
        }

        return;
      }

      if (!v.submissionIndicationStatus) {
        directoryName = directoryName ? `${directoryName}, ${statusInformation.directoryName}` : statusInformation.directoryName;
      }
    });

    if (!directoryName) {
      return;
    }

    switch (v.submissionIndicationStatus) {
      case 'error':
        return;
      case 'warning':
      case 'success':
        v.submissionIndicationText = `${directoryName} submitted`;
        break;
      case 'inProgress':
        v.submissionIndicationText = `${directoryName} submission in process`;
        break;
      default:
        v.submissionIndicationText = `${directoryName} not submitted`;
    }
  };

  let init = (params = {}, query = '') => {
    if (isPostponedByLostSelectionDialog(params, query)) {
      return;
    }

    if (timerId != null) {
      clearTimeout(timerId);
    }

    $params = params;
    $query = query;
    $isLicensor = User.isLicensor();

    QuickFilters.setSyncFilters({
      licensorFilters: ['Licensee', 'Brand', 'Subbrand', 'LicenseOwner'],
      licenseeFilters: ['Licensor', 'Brand', 'Subbrand']
    });

    if (params && params.action && params.id) {
      if (params.action == 'customize') {
        return customizePage(params.id);
      } else if (params.action == 'masterProductData') {
        return masterProductDataPage(params.id);
      } else if (params.action == 'productApprovalShort') {
        return productApprovalShortPage(params.id);
      } else if (params.action == 'productApprovalRegular') {
        return productApprovalRegularPage(params.id);
      } else if (params.action == 'productApprovalFull') {
        return productApprovalFullPage(params.id);
      }
    }

    if (!params || (params && params.action != 'dialog')) {
      UI.block('#page');
    } else {
      UI.block('.modal-content');
    }

    let requestData = {};
    if (params && params.action == 'dialog') {
      requestData.requestPage = 'prelistings';
      requestData.excludeIds = params.excludeIds ? params.excludeIds : [];
      if (!params.reload) {
        requestData.page = 1;
      }
    }

    lastQuery = { params: params, query: query };

    $.when(App.ajaxData(`prelistings/filter`, requestData, 'POST')).done((pageData) => {
      pageData.data = mapping.prelisting(pageData.data, params);
      pageData.isLicensor = $isLicensor;

      // If Page in Dialog
      if (params && params.action == 'dialog') {
        pageData = {
          ...pageData,
          ...{
            dialog: true,
            callback: params.callback,
            reload: params.reload,
            query: query,
            $lang: $lang
          }
        };
        return dialogPage(pageData);
      }

      let template = require('./tmpl/prelisting.hbs');
      UI.page(template, pageData).then(() => {
        App.pageData('selectPrelisting', []);
        App.pageData('selectAllPrelisting', false);

        Prelisting.pageinit(pageData);
      });
    });
  };

  let pageinit = (pageData) => {
    contentInit();

    // Page in dialog opened
    if (pageData.dialog) return pageDialogInit();

    pagePageInit(pageData);

    UI.unblock('#page');
  };

  let pagePageInit = (pageData) => {
    QuickFilters.init({ selector: '#prelistingsQuickFilters' });

    SortFilter.updateCheckBoxLists();

    if (!pageData?.pageReload) {
      SortFilter.init({
        selector: '#prelistingSearchForm',
        update: reloadPageWithClearingSelectAll
      });
    }

    $('#page')
      .off()
      .on('click', '.js-action-submitbom', handleBOMsubmit)
      .on('click', '.js-action-assigntask', assignTask)
      .on('click', '.js-action-approve-reject', approveReject)
      .on('click', '.card-item-prelisting .color-variants-morelink', productInfoDialog)
      .on('click', '.card-item-prelisting .js-action-exportPdfDialog', exportPdfDialog)
      .on('dblclick', '.card-item-prelisting .detail', productInfoDialog)
      .on('change', '.card-item-prelisting .item-color-checkbox', updateMockupColor)
      .on('click', '.card-item-prelisting .artwork-name', function () {
        let id = $(this).data('id') || false;
        let pageData = App.pageData('data') || [];

        const accountId = pageData.find((p) => p?.assets?.some((a) => a.objectId === id))?.accountId;

        if (!id || !accountId) {
          return;
        }

        ArtworkInfo.dialog(id, reloadPage, false, accountId);
      })
      .on('click', '.card-item-prelisting .blank-name', function () {
        let id = $(this).data('id') || false;
        BlankInfo.dialog(id, reloadPage);
      })
      .on('click', '.js-action-folderdialog', Listings.folderDialog)
      .on('click', '.js-action-preview', () => {
        $router.push('/prelistings/preview');
      });

    $('#prelistingsApproveBtn').off().on('click', () => {
      sendApprove();
    });

    $('.js-action-toggleState').off().on('click', moveSelectedToListings);

    $('.js-btnMockupComparison').on('click', () => {
      window.location.href = `${window.location.origin}/mockup-comparison`;
    });

    $('.js-downloadFilesForPersonalization').on('click', downloadFilesForPersonalization);
    $('.js-toggleState').on('click', moveToListings);
  };

  let reloadPageWithClearingSelectAll = () => {
    App.pageData('selectPrelisting', []);
    App.pageData('selectAllPrelisting', false);
    reloadPage();
  };

  let contentInit = () => {
    // Colors
    ColorVariants.init();

    // Variants images
    $('.card-owl-carousel').owlCarousel({
      items: 1,
      dots: false,
      nav: true,
      margin: 0
    });

    // Images ZOOM-IN
    UI.zoomInInitGallery('zoomimage', `.img-box`);
  };

  let pageDialogInit = () => {
    Common.paginationDialog({
      paginationWraper: '.prelistingsPaging',
      pagename: 'prelistings',
      action: reloadDialog
    });

    SortFilter.init({
      selector: '#prelistingSearchForm',
      pagename: 'prelistings',
      update: reloadDialog
    });

    dataBinder.dataBind(document.body, window);

    $('.modal-artworks-page .modal-body').scrollTop(0);
    UI.unblock('.modal-content');
  };

  let reloadPage = () => {
    App.ajaxAbortAll();
    UI.block('#page');

    let selectPrelisting = App.pageData('selectPrelisting') || [];
    let selectAllPrelisting = App.pageData('selectAllPrelisting') || false;

    $.when(App.ajaxData(`prelistings/filter`, {}, 'POST')).done((pageData) => {
      // Mapping Page Data
      pageData.data = mapping.prelisting(pageData.data);
      pageData.isLicensor = $isLicensor;

      let template = require('./tmpl/partial/content.hbs');
      UI.render('#pageContent', template, pageData).then(() => {
        App.pageData('selectPrelisting', selectPrelisting);
        App.pageData('selectAllPrelisting', selectAllPrelisting);

        Prelisting.pageinit({ pageReload: true });
      });
    });
  };

  let reloadDialog = (query = '') => {
    UI.block('.modal-content');
    let params = lastQuery.params;
    if (!params) {
      params = { action: 'dialog' };
    }
    params.reload = true;
    init(params, query);
  };

  let dialogPage = (pageData) => {
    let template = require('./tmpl/prelisting.hbs');
    if (pageData.reload) {
      // Copy Store Dialog
      let copyStoreDialog = App.pageData('copyStore.step') || false;
      if (copyStoreDialog) {
        $('#copyStoreDialogContent').empty().html(template(pageData));
      } else {
        $('.modal-prelistings-page .bootbox-body').html(template(pageData));
      }

      let selectPrelistingDialogIds = App.pageData('selectPrelistingDialogIds') || [];
      App.pageData('selectPrelistingDialogIds', selectPrelistingDialogIds);

      pageinit(pageData);
      return;
    }

    bootbox
      .dialog({
        title: 'Select Prelistings',
        message: template(pageData),
        size: 'xl',
        className: 'modal-scrolled-content modal-prelistings-page',
        buttons: {
          Ok: {
            label: `<i class="fal fa-check-double"></i> ${$lang.btn.applay}`,
            className: 'btn btn-primary',
            callback: pageData.callback
          },
          Close: {
            label: `<i class="fal fa-times"></i> ${$lang.btn.cancel}`,
            className: 'btn btn-default'
          }
        }
      })
      .init(() => {
        pageinit(pageData);
      });
  };

  let selectAll = (event) => {
    let isCheked = $(event.currentTarget).prop('checked');
    App.pageData('selectAllPrelisting', isCheked);

    if (!isCheked) {
      App.pageData('selectPrelisting', []);
      return;
    }

    UI.block('#page');
    $.when(App.ajaxData(`prelistings/select/all/${User.accountID()}`, {}, 'POST'))
      .done((res) => {
        App.pageData('selectPrelisting', res.data);
        selectPrelistingPostHandler();
      })
      .always(() => {
        UI.unblock('#page');
      });
  };

  let selectPrelistingPostHandler = () => {
    const data = App.pageData('data') || [];
    const selectPrelisting = App.pageData('selectPrelisting') || [];

    if (selectPrelisting.length > data.length) {
      App.pageData('selectPrelistingInOnePage', false);

      return;
    }

    const selectPrelistingInOnePage = selectPrelisting.every((sp) => data.some((d) => d.id === sp.id));

    App.pageData('selectPrelistingInOnePage', selectPrelistingInOnePage);
  };

  let updateMockupColor = (e) => {
    const target = $(e.target);
    const id = target.data('entityid');
    const name = target.attr('name');
    const isChecked = target.prop('checked');

    if (!id || !name) {
      return false;
    }

    let pageData = App.pageData('data');
    let idx = pageData.findIndex((obj) => obj.id === id);
    let itemData = App.pageData('data[' + idx + ']');

    if (!isChecked) {
      // Check if not last approved color
      if (itemData.variants.filter((f) => f.approved).length <= 1) {
        target.prop('checked', !isChecked);
        return;
      }
    }

    const payload = {
      id: id,
      accountId: pageData[idx].accountId,
      title: '_',
      blank: { id: null, title: '_' },
      productInStores: [],
      salesByStore: [],
      variants: [
        {
          color: name,
          approved: isChecked
        }
      ]
    };

    UI.block('#page');
    $.when(App.ajaxData('prelistings/selectColors', payload, 'POST')).done((res) => {
      if (!res.isSuccess) {
        target.prop('checked', !isChecked);

        if (res.validationErrors) {
          if (res.validationErrors.length && res.validationErrors[0].errorType == 5) {
            UI.errorMultiMessage(res.validationErrors[0].details);
          }
        }
        return;
      }

      let result = Array.isArray(res.object) ? res.object : [res.object];

      let cItem = mapping.prelisting(result)[0];
      let objIndex = pageData.findIndex((obj) => obj.id === cItem.id);
      App.pageData('data[' + objIndex + ']', cItem);

      // Update Item Color variants
      ColorVariants.reload(cItem);

      let approved = cItem.variants.find((f) => f.approved);
      if (approved && approved.frameImages.length) {
        approved.frameImages.forEach((item, index) => {
          UI.reInitZoom($(`[data-itemid=${cItem.id}]`).find('.img-bg-square').eq(index), item.imageFileUrl);
        });
      }

      let approvedForGallery = cItem.variants
        .filter((f) => f.approved)
        .filter((_, i) => i !== 0)
        .reduce((acc, v) => acc.concat(v.frameImages.map((a) => a.imageFileUrl)), []);

      if (approvedForGallery && approvedForGallery.length) {
        UI.reInitGallery(`[data-itemid=${cItem.id}] .img-box`, approvedForGallery);
      }

      //updateItemFolderStatus(cItem.id);

      UI.unblock('#page');
    });
  };

  let customizePage = (id) => {
    DesignStudio.page(id);
  };

  let masterProductDataPage = (id) => {
    MasterProductData.init(id, User.accountID(), lastQuery);
  };

  let productApprovalShortPage = (id) => {
    ProductApprovalShort.init('#page', id);
  };

  let productApprovalRegularPage = (id) => {
    ProductApproval.init('#page', id);
  };

  let productApprovalFullPage = (id) => {
    ProductApprovalFull.init('#page', id);
  };

  let sendApprove = (id = false) => {
    let selectPrelisting = App.pageData('selectPrelisting') || false;
    let $data = App.pageData('data');
    let idsCollection = {};

    if (!id && !selectPrelisting) {
      return alert('Not selected');
    }

    // Single item
    if (id) {
      let item = _.findWhere($data, { id: id });
      idsCollection[item.id] = item.accountId;
    } else {
      // Selected Items
      selectPrelisting.forEach((item) => {
        let cPrelisting = _.findWhere($data, { id: item.id });
        idsCollection[cPrelisting.id] = cPrelisting.accountId;
      });
    }

    if (!Object.keys(idsCollection).length) return;

    // Item Card loader
    Object.keys(idsCollection).forEach((id) => ItemCardNotice.loader({ id }));

    $.when(App.ajaxData(`prelistings/approve/${User.accountID()}`, { ids: idsCollection }, 'POST')).done((res) => {
      if (res.isSuccess) {
        App.pageData('selectAllPrelisting', false);
        App.pageData('selectPrelisting', []);

        UI.notify({ text: $lang.alert.ProcessUploadingStarted, type: 'info', icon: 'fal fa-sync' });
      } else {
        let text = res.errorInformation.errorReason;
        Object.keys(idsCollection).forEach((id) => ItemCardNotice.error({ id, text }));
      }
    });
  };

  let downloadFilesForPersonalization = (e) => {
    const prelistingId = e.target.closest('[data-prelistingid]').getAttribute('data-prelistingid');

    UI.blockPage();

    Common.saveFile(
      $config.apiURL + `MasterProductData/download/${User.accountID()}/${prelistingId}/images`,
      `prelisting-images-${prelistingId}`,
    );
  };

  let moveToListings = (e) => {
    const prelistingId = e.target.closest('[data-prelistingid]').getAttribute('data-prelistingid');
    UI.block('#page');
    Listings.toggleState([prelistingId], 'prelistings', reloadPage);
  };

  let moveSelectedToListings = () => {
    let selected = App.pageData('selectPrelisting');
    if (!selected?.length) {
      return;
    }

    UI.block('#page');
    Listings.toggleState(selected.map((s) => s.id), 'prelistings', reloadPageWithClearingSelectAll);
  };

  /*let updateItemFolderStatus = (id) => {
    let itemCard = $(`[data-itemid="${id}"]`);
    let bomFolderStatus = $('.js-BOM-folder', itemCard).data('folderstatus');
    let ksfFolderStatus = $('.js-KSF-folder', itemCard).data('folderstatus');
    if (bomFolderStatus == 2) {
      $('.js-BOM-folder .status-label', itemCard).removeClass('text-success').addClass('text-warning');
    }
    if (ksfFolderStatus == 2) {
      $('.js-KSF-folder .status-label', itemCard).removeClass('text-success').addClass('text-warning');
    }
  };*/

  let handleBOMsubmit = (e) => {
    let selectPrelisting;
    let target = $(e.target).hasClass('js-action-submitbom')
      ? $(e.target)
      : $(e.target).closest('.js-action-submitbom');
    let type = target.data('submittype');
    let card = target.closest('.card-item');

    if (!card.length || !card.data('itemid')) {
      selectPrelisting = App.pageData('selectPrelisting');
    } else {
      const prelisting = (App.pageData('data') || []).find((p) => p.id === card.data('itemid'));
      selectPrelisting = [{ id: prelisting.id, accountId: prelisting.accountId }];
    }

    if (!type || !selectPrelisting.length) return;

    let idsCollection = selectPrelisting.reduce((acc, item) => {
      acc[item.id] = item.accountId;

      return acc;
    }, {});

    let page = $('#pagedialog').val() == 1 ? 'dialog' : 'Prelisting';
    BOM.submit(idsCollection, type, page);
  };

  let deleteDialog = (id = false) => {
    let name = 'selected Mockups';

    const item = _.findWhere(App.pageData('data'), { id: id });

    if (item) {
      name = '<br><b>' + item.title + '</b>';
    }

    UI.deleteConfirm(name).then((yes) => (yes ? deletePrelisting(item) : false));
  };

  let deletePrelisting = (deleteItem) => {
    let selectPrelisting = App.pageData('selectPrelisting') || [];
    let selectAllPrelisting = App.pageData('selectAllPrelisting') || false;
    let idsToDelete = deleteItem
      ? { [deleteItem.id]: deleteItem.accountId }
      : selectPrelisting.reduce((acc, item) => ({ ...acc, [item.id]: item.accountId }), {});

    const ids = Object.keys(idsToDelete);

    if (!ids.length) {
      return alert('Prelisting not found');
    }

    bootbox.hideAll();

    UI.block('#page');
    $.when(App.ajaxData('prelistings/delete', { ids: idsToDelete, isConfirm: true }, 'POST')).done(() => {
      if (selectPrelisting.length) {
        // If was selected - remove from selected Array
        ids.forEach((id) => {
          selectPrelisting = selectPrelisting.filter((item) => {
            if (item.id != id) return item;
          });
        });
      }

      UI.notify({ text: $lang.alert.SuccessfullySaved, type: 'success' });

      App.pageData('selectAllPrelisting', selectAllPrelisting);
      App.pageData('selectPrelisting', selectPrelisting);
      reloadPage();
    });
  };

  let exportPdfDialog = (e) => {
    let thisEl = $(e.target).hasClass('card-item') ? $(e.target) : $(e.target).closest('.card-item');
    let id = thisEl.data('itemid');

    approvalPdfDialog.open(id);
  };

  let productInfoDialog = (e) => {
    if ($(e.target).closest('.kt-checkbox').length) {
      return;
    }
    let thisEl = $(e.target).hasClass('card-item') ? $(e.target) : $(e.target).closest('.card-item');
    let id = thisEl.data('itemid');
    let prelisting = _.findWhere(App.pageData('data'), { id: id });
    if (!prelisting) {
      return;
    }

    $productInfoDialogParams = {
      pageUrl: 'prelistings',
      accountId: User.accountID(),
      onClose: updateColorVariants,
      buttons: {
        storeData: true,
        productionData: true,
        customize: true,
        mockupComparison: true,
        sendApprove: prelisting.status === 0 ? false : sendApprove,
        sendSample: sendSampleDialog,
        downloadApproval: approvalPdfDialog.open,
        delete: deleteDialog,
        approveReject: true,
        bominfo: true,
        submitBOM: BOM.submit
      }
    };

    ProductInfo.dialog(prelisting.id, $productInfoDialogParams);
  };

  let updateColorVariants = () => {
    init($params, $query);
  };

  let sendSampleDialog = (id) => {
    let prelisting = _.findWhere(App.pageData('data'), { id: id });
    if (!prelisting) {
      return;
    }

    prelisting = $.extend(true, {}, prelisting);

    SendSample.dialog({
      data: prelisting,
      ok: init,
      lastQuery: lastQuery
    });
  };

  let sendApprovalDialog = (id) => {
    let prelisting = _.findWhere(App.pageData('data'), { id: id });
    if (!prelisting) {
      return;
    }

    prelisting = $.extend(true, {}, prelisting);

    SendApproval.dialog({
      data: prelisting,
      ok: init,
      lastQuery: lastQuery
    });
  };

  let assignTask = (e) => {
    AssignTasks.handleAssignTask({
      e: e,
      elClassName: 'js-action-assigntask',
      selectedPageField: 'selectPrelisting',
      requestPage: 7
    });
  };

  let approveReject = (e) => {
    let target = $(e.target).hasClass('js-action-approve-reject')
      ? $(e.target)
      : $(e.target).closest('.js-action-approve-reject');
    let id = target.data('itemid');

    const singleItem = id ? App.pageData('data').find((i) => i.id == id) : null;
    const selectedItems = singleItem ? [singleItem] : App.pageData('selectPrelisting');
    const mapped = selectedItems.reduce((acc, item) => ({ ...acc, [item.id]: item.accountId }), {});

    ApprovalRejection.dialog({
      items: mapped,
      page: 'prelistings',
      callback: () => {
        App.pageData('selectPrelisting', []);
        App.pageData('selectAllPrelisting', false);
        reloadPage();
      }
    });
  };

  let lostSelectionDialog = (callback = false) => {
    if (!callback) {
      return;
    }

    bootbox.dialog({
      title: 'Selection will be lost',
      closeButton: false,
      message: `<h5>Are you sure you want to leave this page?<br>The selection will be lost.</h5>`,
      className: 'modal-danger',
      buttons: {
        Ok: {
          label: 'OK',
          className: 'btn btn-danger',
          callback: function () {
            callback(true);
          }
        },
        Cancel: {
          label: 'Cancel',
          className: 'btn btn-link',
          callback: function () {
            callback(false);
          }
        }
      }
    });
  };

  let isPostponedByLostSelectionDialog = (params = {}, query = '') => {
    if (!query) {
      return false;
    }

    const selectPrelisting = App.pageData('selectPrelisting');

    if (selectPrelisting?.length && $query !== query) {
      lostSelectionDialog((result) => {
        if (!result) {
          history.back();
          return;
        }

        App.pageData('selectPrelisting', []);
        init(params, query);
      });
      return true;
    }

    return $query === query;
  };

  let clear = () => {
    $query = '';
  };

  return {
    init,
    clear,
    pageinit,
    selectAll,
    selectPrelistingPostHandler,
    deleteDialog,
    sendApprove,
    sendSampleDialog,
    sendApprovalDialog,
    updateColorVariants,
    assignTask,
    mapping
  };
})();
